/**
 * Plays its video only while at least a quarter of it is in the viewport. With preload="none" on the video, which the
 * markup has to set, nothing downloads before it plays.
 */
if (!customElements.get('video-in-view')) {
  class VideoInView extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      // A busy main thread can queue several entries; the last one is current
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.at(-1).isIntersecting) {
            // A pause interrupting play() or a blocked autoplay (e.g. iOS Low Power Mode) rejects; the poster stays
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        },
        { threshold: 0.25 },
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('video-in-view', VideoInView);
}
